export default __webpack_public_path__ + "static/app-landing-page-0-ec509de2b25713792014ef839c4a7571.png";